const { Array } = require('../../Array/Array')

/**
 * Visszaadja az összes évet, amely a két dátum között van (nyílt intervallum).
 * @param {string} start - Kezdő dátum.
 * @param {string} end - Vége dátum.
 * @returns {readonly string[]} Az évek.
 */
module.exports.getYearsBetweenDates = function getYearsBetweenDates (start, end) {
  const startDate = new Date(start)
  const endDate   = new Date(end)

  const startYear = startDate.getFullYear()

  const ageDifference = endDate.getFullYear() - startYear

  if (ageDifference < 0) {
    return []
  }

  const years = Array.times(ageDifference, (diff) => {
    return (startYear + diff + 1).toString()
  })

  return [ startYear.toString(), ...years ]
}
